import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { ToolbarButton, RangeControl, Dropdown } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { search } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import { MIN_ZOOM, MAX_ZOOM, POPOVER_PROPS } from './constants';
import { useImageEditingContext } from './context';
export default function ZoomDropdown() {
  const {
    isInProgress,
    zoom,
    setZoom
  } = useImageEditingContext();
  return createElement(Dropdown, {
    contentClassName: "wp-block-image__zoom",
    popoverProps: POPOVER_PROPS,
    renderToggle: _ref => {
      let {
        isOpen,
        onToggle
      } = _ref;
      return createElement(ToolbarButton, {
        icon: search,
        label: __('Zoom'),
        onClick: onToggle,
        "aria-expanded": isOpen,
        disabled: isInProgress
      });
    },
    renderContent: () => createElement(RangeControl, {
      label: __('Zoom'),
      min: MIN_ZOOM,
      max: MAX_ZOOM,
      value: Math.round(zoom),
      onChange: setZoom
    })
  });
}
//# sourceMappingURL=zoom-dropdown.js.map